
import React from "react"
import { useState, } from "react"
import { makeStyles } from "@material-ui/core"
import { Box, MenuList, MenuItem } from '@material-ui/core';
import Icon from '@material-ui/core/Icon';
import Popover from '@mui/material/Popover';
import { useHistory } from "react-router-dom";
import { genfunction } from "helpers";

const useStyles = makeStyles((theme) => ({
    popover: {
        pointerEvents: 'none',
    },
    paper: {
        display: 'flex',
        marginTop: theme.spacing(1),
        boxShadow: theme.shadows[5]
    },
    textUnderline: {
        flex: 1,
        paddingLeft: '5px',
        display: 'inline-block',
        position: 'relative',
        '&::after': {
            content: '""',
            position: 'absolute',
            left: 0,
            bottom: -2,
            height: 2,
            width: 0,
            backgroundColor: theme.palette.primary.main,
            transition: 'width 0.3s ease',
        },
        '&:hover::after': {
            width: '100%',
        },
    },

    menuItem: {
        padding: theme.spacing(1.5, 2),
    },

    icon: {
        color: theme.palette.primary.main,

    }

}))

export default function RecursiveHorizontalMenu({ menu, anchorEl, onClose, level, handlePageClick }) {
    const [submenuAnchor, setSubmenuAnchor] = useState(null);
    const [openIndex, setOpenIndex] = useState(null);

    const classes = useStyles();

    const handleClose = () => {
        setSubmenuAnchor(null);
        setOpenIndex(null);
        onClose();

    };

    const handleSubmenuOpen = (event, index) => {
        setSubmenuAnchor(event.currentTarget);
        setOpenIndex(index);
    };

    const handleSubmenuClose = () => {
        setSubmenuAnchor(null);
        setOpenIndex(null);
    };

    const checkIsPage = (child) => {

        if (!genfunction.IsArrayNotEmptyNullUndefined(child?.MenuAndPages)) {
            handlePageClick(child?.PageURL);
        }
    }


    return (
        <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={level === 1 ? { vertical: 'bottom', horizontal: 'left' } : { vertical: 'top', horizontal: 'right' }}
            transformOrigin={{ vertical: "top", horizontal: "left" }}
            style={{ zIndex: 1300 + level }}
            id="mouse-over-popover"
            className={classes.popover}
            classes={{ paper: classes.paper }}
            disableRestoreFocus
            disableAutoFocus
            disablePortal={true}
            PaperProps={{
                onMouseLeave: onClose,
                style: {
                    pointerEvents: 'auto'
                }
            }}>

            <MenuList dense id="simple-menu" >
                {menu?.MenuAndPages?.map((child, i) => {

                    return (<div
                        key={i}
                        onMouseEnter={(e) => handleSubmenuOpen(e, `child-${i}`)}
                        onMouseLeave={handleSubmenuClose}
                        style={{ position: "relative" }}
                    >
                        <MenuItem className={classes.menuItem} key={`child-${i}`}
                            onClick={() => checkIsPage(child)}

                        >
                            {
                                child?.Icon ? <Icon className={classes.icon}>{child?.Icon}</Icon>
                                    : <Box sx={{ width: 24 }} />}
                            <span className={classes.textUnderline}>

                                {genfunction.replaceEscapeCharacters(child?.Title)}
                            </span>


                            {genfunction.IsArrayNotEmptyNullUndefined(child?.MenuAndPages) &&
                                <>
                                    <Icon fontSize="small" className={classes.icon} >chevron_right</Icon>
                                    {openIndex === `child-${i}` && (
                                        <RecursiveHorizontalMenu
                                            menu={child}
                                            anchorEl={submenuAnchor}
                                            onClose={() => { }}
                                            level={level + 1}
                                            handlePageClick={handlePageClick}
                                        />
                                    )}
                                </>
                            }

                        </MenuItem>
                    </div>)
                })}

            </MenuList>
        </Popover >
    );
}


